import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {AutoCompleteService} from "../../shared/components/autocomplete/autocomplete.service";
import {templateStorage} from "./data.service";

@Injectable()
export class TemplateService {

    constructor(
        private _router: Router,
        private _autocompleteService: AutoCompleteService
    ) { }

    //session
    setSessionStorage(item: any) {
        var object: string = JSON.stringify(item);
        sessionStorage.setItem(templateStorage + '-new', object);
    }

    getSessionStorage() {
        var item: string = sessionStorage.getItem(templateStorage + "-new");
        return JSON.parse(item);
    }

    clearSessionStorage() {
        sessionStorage.removeItem(templateStorage + "-new");
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/rastreamentos/templates/template.service.ts
 **/